import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import TabContext from '@mui/lab/TabContext';
import { Paper } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import TabList from '@mui/lab/TabList';

import { getAppUser } from '../../../../services/user.service';

import { AuthProfile } from '../../../../types/AuthProfile';
import { AppUser } from '../../../../types/AppUser';

import AppUserForm from '../../account/appUserForm';
import AppUserDetail from '../../account/appUserDetail';

import UserScopeView from './userScopeView';
import UserPermissions from './userPermissions';
import UserMetadata from './UserMetadata';
import AssociatedImeiTabs from './AssociatedImeiTabs';
import AppUserRoleWarnings from './appUserRoleWarnings';
import UserRoles from './UserRoles';

// Styles
import '../../../../styles/muiTabs.scss';

export default function AppUserOverview() {
  const [activeTab, setActiveTab] = useState<string>('general');
  const [authProfile, setAuthProfile] = useState<AuthProfile>();
  const [appUser, setAppUser] = useState<AppUser>();
  const { id } = useParams();

  if (!id) {
    return <em>Error: need user id</em>;
  }

  useEffect(() => {
    getAppUser(id)
      .then((response) => setAppUser(response))
      .catch((err) => console.error('Unable to fetch user', err));
  }, [id]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => setActiveTab(newValue);

  const appUserDetail = appUser ? <AppUserDetail appUser={appUser} /> : '';

  return (
    <>
      {appUserDetail}
      <TabContext value={activeTab}>
        <div className='app-tabs'>
          <TabList onChange={handleTabChange}>
            <Tab label='Details' value='general' sx={{ textTransform: 'none' }} />
            <Tab label='Roles' value='roles' sx={{ textTransform: 'none' }} />
            <Tab label='Permissions' value='permissions' sx={{ textTransform: 'none' }} />
            <Tab label='Scopes' value='scopes' sx={{ textTransform: 'none' }} />
            <Tab label='Metadata' value='metadata' sx={{ textTransform: 'none' }} />
            <Tab label='Mobile Logs' value='mobile logs' sx={{ textTransform: 'none' }} />
          </TabList>
        </div>
        <TabPanel value={'general'}>
          <AppUserForm appUser={appUser} setAppUser={setAppUser} />
        </TabPanel>
        <TabPanel value={'roles'}>
          <AppUserRoleWarnings user={appUser} />
          <UserRoles appUserId={id} authProfile={authProfile} setAuthProfile={setAuthProfile} />
        </TabPanel>
        <TabPanel value={'permissions'}>
          <UserPermissions userId={id}></UserPermissions>
        </TabPanel>
        <TabPanel value={`scopes`}>
          <Paper>
            <UserScopeView userId={id} />
          </Paper>
        </TabPanel>
        <TabPanel value={'metadata'}>
          <UserMetadata userId={id} />
        </TabPanel>
        <TabPanel value={'mobile logs'}>
          <AssociatedImeiTabs associatedImeis={appUser?.associatedImeis ?? []} />
        </TabPanel>
      </TabContext>
    </>
  );
}
